var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"LoginSuccess",attrs:{"data-title":"登录成功"}},[_c('div',{staticClass:"success fc-primary"},[_c('van-icon',{attrs:{"name":"checked","size":"40px"}}),_c('div',{staticClass:"pt5"},[_vm._v("登录成功")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }